// export const REGEX_VALIDATION_EMAIL = /^([a-zA-Z0-9_\-\.]+)+(\+[a-zA-Z0-9_\-\.]+)?@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/i;
export const REGEX_VALIDATION_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

